import { render } from "./wokerDetail5.vue?vue&type=template&id=ff5e00ce&scoped=true"
import script from "./wokerDetail5.vue?vue&type=script&lang=js"
export * from "./wokerDetail5.vue?vue&type=script&lang=js"

import "./wokerDetail5.vue?vue&type=style&index=0&id=ff5e00ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff5e00ce"]])

export default __exports__